<template>
  <div class="login">
    <h3>Sign In</h3>
    <input type="text" v-model="email" placeholder="Email"><br>
    <input type="password" v-model="password" placeholder="Password"><br>
    <button v-on:click="signIn">Connection</button>
    <p>Don't have an account? You can <router-link to="/sign-up">create one here!</router-link></p>
    <p>You can also participate <a href="#" v-on:click="anonSignIn">anonymously</a>.</p>
  </div>
</template>

<script>
  import Firebase from 'firebase'
  export default {
    name: 'login',
    data () {
      return {
        email: '',
        password: ''
      }
    },
    methods: {
      signIn () {
        Firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
          (user) => {
            this.$router.replace('hello')
          },
          (err) => {
            alert('Oops. ' + err.message)
          }
        );
      },
      anonSignIn () {
        Firebase.auth().signInAnonymously().then(
          (user) => {
            this.$router.replace('hello')
          },
          (err) => {
            alert('Oops. ' + err.message)
          }
        );
      }

    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Login.vue?4e82004c